/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { Link, graphql, navigate, withPrefix } from "gatsby";
import Seo from "../components/seo";
import Layout from "../components/layout";
import { Section, Container, MarkdownContent, BreadCrumb } from "../components/Section";
import { Sidebar, SidebarDefault, SidebarDefaultBody, SidebarForm } from "../components/Sidebar";
import SimilarBuildingModal from "../components/SimilarModal";
import Badge from "../components/Badge";
import RequestForm from "../components/RequestForm";
import Recommendations from "../components/Recommendations";
import PhoneCta from "../components/PhoneCta";
import ProductInfo from "../components/ProductInfo";
import { FbShareIcon, TwitterIcon, PinterestIcon, ShareIcon } from "../components/Icons";
import { setCrmSetting, embedCrmScript } from "src/utils";
import PointerSm from "../images/pointer-sm.svg";

const ProductDtl = styled.div`
  padding:0;
`;

const ProductCrm = styled.div`
  position: relative;
  .d-none {
    display: none;
    opacity: 0;
  }

  .for-canvas-size {
    canvas {
      width: 100% !important;
      height: 95% !important;
    }
  }
`;

const ShareNetwork = styled.div`
  position:absolute;  
  top:190px;  
  left: 0;
  z-index: 14;
  display: inline-block;
  transition: all 0.5s;
  width: 30px;
  @media (max-width: 992px) {        
    transform: translateX(-100%);
    &.active {
      transform: translateX(0);    
      .toggle {
        display:block;
        left:auto;
        svg {
          transform: scaleX(-1);
        }
      }
    }
  }
`;

const SharAction = styled.button`
  background:#e9242a;
  border: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  padding: 0;
  transition: all 0.5s;
  border-radius: 0 100% 100% 0;
  height: 30px;
  width: 30px;
  top: 15px;
  right: -30px;
  @media (min-width: 992px) {    
    display: none;
    &:hover {
      background: #bd100b;
    }
  }
  svg {
    width: 12px;
    fill: #fff;
  }
`;

const ShareDropdown = styled.div`
  background-color:#373636;
  padding: 5px;
  border-radius: 0 10px 10px 0;
`;

const ShareList = styled.ul`
  padding:0;
  margin:0;
`;

const ShareItemDrop = styled.li`
  list-style: none;    
  padding:5px 0;
  margin:0;
  a{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    svg{
      fill:#fff;
    }
    &:hover{
      svg{
        fill:#E9242A;
      }
    }
  }
`;

const ListBadge = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin:0 0 30px;
  .badge {
    margin: 5px;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
  @media (min-width: 1200px) {
    margin: 0 -30px;
  }
`;

const LeftGrid = styled.div`
  position: relative;
  width: 100%;
  padding: 0 15px;
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  @media (min-width: 1200px) {
    padding: 0 30px;
  }
  @media (max-width: 991.98px) {
    .similar-modal {
      display: none;
    }
  }
`;

const RightGrid = styled.div`
  position: relative;
  width: 100%;
  padding: 0 15px;
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
    .similar-modal {
      display: none;
    }
  }
  @media (min-width: 1200px) {
    padding: 0 30px;
  }
`;

const SimilarGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  @media (min-width: 1200px) {
    margin: 0 -15px;
  }
  .card {
    border: none;
    .card-figure {
      .gatsby-image-wrapper {
        border-radius: 5px 5px 0 0;
      }
    }
    .card-body {
      padding: 0;
    }
    .card-footer {
      padding: 20px;
      + .card-footer {
        padding-top: 20px;
      }
    }

    .product-name {
      @media (min-width: 768px) { 
        font-size: 18px;
        line-height: 26px;
      }
    }
  }
`;

const SimilarGridItem = styled.div`
  position: relative;  
  width: 100%;
  padding: 0 10px;
  @media (min-width: 576px) {
    max-width: 50%;
    flex: 0 0 50%;
  }
  @media (min-width: 992px) {
    padding: 0 15px;
  }
`;

const SimilarModal = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const SimilarTitle = styled.h2`
  text-transform: capitalize;
  font-size: 18px;
  line-height: 30px;
  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 30px;
  }
  @media (min-width: 992px) {
    font-size: 24px;
    line-height: 34px;
  }
  @media (min-width: 1200px) {
    font-size: 30px;
    line-height: 40px;
  }
  @media (min-width: 1600px) {
    font-size: 36px;
    line-height: 46px;
  }
`;

const MarkdownContents = styled(MarkdownContent)`
  h2 {
    text-transform: capitalize;
  }
`;

const BuildingDescription = styled.div``;

const BuildingSpecifictions = styled.div`
  ul,
  ol {
    li {
      padding-left: 20px;
      font-size: 16px;
      line-height: 28px;
      &:before {
        content: url(${PointerSm});
        margin-left: -20px;
        width: 20px;
        vertical-align: 0;
      }
      @media (min-width: 1200px) {
        font-size: 18px;
        line-height: 30px;
      }
      + li {
        margin-top: 5px;
      }
    }
  }
`;

const ProductTemplatePage = ({ location, data }) => {
  const productData = data.contentfulProduct;
  const totalProducts = data.allContentfulProduct.edges;
  const [isActive, setIsActive] = useState(false);
  const senseiProductId = data.contentfulProduct.senseiProductId ? btoa(data.contentfulProduct.senseiProductId) : "";

  const temp = productData.title.replace(/[^\w\s]+/gi, " ").replace(/  +/g, " ");
  const titleUrl = temp.split(" ").join("-").toLowerCase();
  const categories = productData.productCategories.map((cat) => cat.title);
  const relatedProducts = totalProducts.filter((product) => {
    if (product.node.id === productData.id) return false;
    const productCategories = product.node.productCategories.map(
      (cat) => cat.title
    );
    const commonCategories = productCategories.filter((item) =>
      categories.includes(item)
    );
    if (commonCategories && commonCategories.length) return true;
    return false;
  });

  const pageUrl = `https://www.engineeredmetalbuildings.com${productData.url}`;
  const pageTitle = `${productData.title}`;
  const pageImage = `${productData.image.fluid.srcWebp}`;
  const encodedUrl = encodeURIComponent(pageUrl);
  const encodedTitle = encodeURIComponent(pageTitle);
  const encodedImage = encodeURIComponent(pageImage);

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home Page",
        item: "https://www.engineeredmetalbuildings.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Shop",
        item: "https://www.engineeredmetalbuildings.com/shop/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: `${productData.title}`,
        item: `https://www.engineeredmetalbuildings.com${productData.url}`,
      },
    ],
  };
  const productSchema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: productData.title,
    image: productData.image.fluid.srcWebp,
    description: productData.metaDescription,
    offers: {
      "@type": "Offer",
      url: "https://www.engineeredmetalbuildings.com" + productData.url,
      priceCurrency: "USD",
      price: productData.price,
      availability: "InStock",
      itemCondition: "NewCondition",
      shippingDetails: {
        "@type": "OfferShippingDetails",
        shippingRate: {
          "@type": "MonetaryAmount",
          value: 0,
          currency: "USD",
        },

        shippingDestination: {
          "@type": "DefinedRegion",
          addressCountry: "US",
        },

        deliveryTime: {
          "@type": "ShippingDeliveryTime",
          handlingTime: {
            "@type": "QuantitativeValue",
            minValue: 0,
            maxValue: 1,
            unitCode: "DAY",
          },

          transitTime: {
            "@type": "QuantitativeValue",
            minValue: 1,
            maxValue: 4,
            unitCode: "DAY",
          },
        },
      },
    },
    manufacturer: {
      "@type": "Organization",
      name: "EMB Metal Buildings, LLC",
      url: "https://www.embmetalbuildings.com",
      logo: "https://www.engineeredmetalbuildings.com/static/b81f2bb5f87a3992879586deaa81d02f/88ed0/logo.webp",
      address: {
        "@type": "PostalAddress",
        streetAddress: "340 Centennial Drive",
        addressLocality: "Heyburn",
        addressRegion: "ID",
        postalCode: "83336",
        addressCountry: "US",
      },
      telephone: "(208) 572-1441",
      email: "sales@embmetalbuildings.com",
    },

    review: {
      "@type": "Review",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
        bestRating: "5",
      },
      author: {
        "@type": "Person",
        name: "EMB",
      },
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "5",
      reviewCount: 1,
      ratingCount: 1,
    },
  };
  const schema = [breadcrumbSchema, productSchema];

  // useEffect(() => {
  //   if (senseiProductId && productData.skuNumber) {
  //     document.body.classList.add("active-modal-loader");

  //     setCrmSetting({
  //       sku_id: productData.skuNumber,
  //       product_id: senseiProductId,
  //       product_url: `https://emb-staging.netlify.app/shop/${titleUrl}/`
  //     });

  //     console.log("window.crmSetting:", window.crmSetting);

  //     embedCrmScript({
  //       id: "3d-main-js",
  //       // src: withPrefix("/static/js/main.25de1873.js")
  //       src: withPrefix("/static/js/main.d949e6c6.js")
  //     });
  //   }
  // }, [data.contentfulProduct]);

  const toggleClass = () => {
    setIsActive(prevState => !prevState);
  };

  return (
    <Layout location={location} productURL={productData.url} isShowProduct>
      <Seo
        title={productData.metaTitle}
        description={productData.metaDescription}
        schemaMarkup={schema}
      />
      <Helmet>
        <meta property="og:type" content="product" />
        <meta property="og:title" content={productData.title} />
        <meta property="og:description" content={productData.metaDescription} />
        <meta property="og:image" content={productData.image.fluid.srcWebp} />
        <meta property="og:url" content={"https://www.engineeredmetalbuildings.com" + productData.url} />
        <meta property="og:site_name" content="EMB Metal Buildings" />
        <meta property="product:price:amount" content={productData.price.toLocaleString("en-US")} />
        <meta property="product:price:currency" content="USD" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@EMBMetalBuildings" />
        <meta name="twitter:title" content={productData.title} />
        <meta name="twitter:description" content={productData.metaDescription} />
        <meta name="twitter:image" content={productData.image.fluid.srcWebp} />
        <meta name="twitter:label1" content="Price" />
        <meta name="twitter:data1" content={productData.price.toLocaleString("en-US")} />
        <meta name="twitter:label2" content="Availability" />
        <meta name="twitter:data2" content="In-Stock" />
        {/* {senseiProductId && <link href="/static/css/main.d7216326.css" rel="stylesheet" />} */}
      </Helmet>
      {/* {senseiProductId &&
        <div className="loading-wrapper">
          <div className="loading-inner"><div className="loader"></div></div>
          <div className="loading-text">Hang Tight! <br /> We are Building a Pro Experience.</div>
        </div>
      } */}
      {/* <Section ept="30px" epb="0" xpt="30px" xpb="0" pt="30px" pb="0" bgColor="#fff" className="section-product"> */}
      <Section
          ept="160px"
          epb="0"
          xpt="140px"
          xpb="0"
          pt="100px"
          pb="0"
          bgColor="#fff"
          className="section-product"
        >
        <Container>
          <BreadCrumb className="black">
            <Link to="/">Home</Link>
            <Link to="/shop">Shop</Link>
            <span>{productData.title}</span>
          </BreadCrumb>
        </Container>
        <ShareNetwork className={`sharebox ${isActive ? 'd-none active' : 'd-none'}`}>
          <SharAction className="toggle" onClick={toggleClass}><ShareIcon /></SharAction>
          <ShareDropdown>
            <ShareList>
              <ShareItemDrop><a className="item-link facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noopener noreferrer"><FbShareIcon /></a></ShareItemDrop>
              <ShareItemDrop><a className="item-link twitter" href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}&hashtags=MetalBuildings,SteelGarage`} target="_blank" rel="noopener noreferrer"><TwitterIcon /></a></ShareItemDrop>
              <ShareItemDrop><a className="item-link pinterest" href={`https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`} target="_blank" rel="noopener noreferrer"><PinterestIcon /></a></ShareItemDrop>
            </ShareList>
          </ShareDropdown>
        </ShareNetwork>
        <ProductDtl className="product-dtl">
          <ProductInfo productData={productData} />
          {/* {senseiProductId ?
            <ProductCrm className="product-crm">
              <div id="root"></div>
            </ProductCrm>
            :
            <ProductInfo productData={productData} />
          } */}
        </ProductDtl>
      </Section>
      <Section ept="30px" epb="60px" xpt="20px" xpb="40px" pt="15px" pb="30px" bgColor="#fff" className="section-product-desc">
        <Container>
          <Grid>
            <LeftGrid>
              {!!productData.specifications && (
                <MarkdownContents>
                  <h2>Building Specifications</h2>
                  <BuildingSpecifictions dangerouslySetInnerHTML={{ __html: productData.specifications.childMarkdownRemark.html }} />
                </MarkdownContents>
              )}
              <MarkdownContents>
                {!!productData.description && (
                  <>
                    <h2>Building Description</h2>
                    <BuildingDescription dangerouslySetInnerHTML={{ __html: productData.description.childMarkdownRemark.html }} />
                  </>
                )}
                <h2>Building Tags</h2>
                <ListBadge className="list-badge">
                  {(productData["buildingTags"] || []).map((item) => (
                    <Badge
                      key={item}
                      badgeText={item}
                      onClick={() =>
                        navigate("/shop", {
                          state: { tag: item },
                        })
                      }
                    />
                  ))}
                </ListBadge>
              </MarkdownContents>
              {relatedProducts.length > 0 && (
                <SimilarModal className="similar-modal">
                  <SimilarTitle>Check Out Similar Building Models</SimilarTitle>
                  <SimilarGrid className="similar-grid">
                    {relatedProducts.slice(0, 4).map((pd, i) => (
                      <SimilarGridItem key={i} className="similar-item">
                        <SimilarBuildingModal productData={pd.node} />
                      </SimilarGridItem>
                    ))}
                  </SimilarGrid>
                </SimilarModal>
              )}
            </LeftGrid>
            <RightGrid>
              <Sidebar className="isSticky">
                <SidebarDefault>
                  <SidebarDefaultBody>                   
                    <SidebarForm>
                      <RequestForm
                        location={location}
                        thanksURL="/thank-you-get-in-touch"
                        productData={productData}
                        productName={productData.title}
                      />
                    </SidebarForm>                   
                  </SidebarDefaultBody>
                  <PhoneCta
                    subTitle="Call Now to Learn About Other"
                    phoneTitle="Discounts & Specials on this Building."
                  />
                </SidebarDefault>
                {relatedProducts.length > 0 && (
                  <SimilarModal className="similar-modal">
                    <SimilarTitle>
                      Check Out Similar Building Models
                    </SimilarTitle>
                    <SimilarGrid className="similar-grid">
                      {relatedProducts.slice(0, 4).map((pd, i) => (
                        <SimilarGridItem key={i} className="similar-item">
                          <SimilarBuildingModal productData={pd.node} />
                        </SimilarGridItem>
                      ))}
                    </SimilarGrid>
                  </SimilarModal>
                )}
                <Recommendations />
              </Sidebar>
            </RightGrid>
          </Grid>
        </Container>
      </Section>
    </Layout>
  );
};

export default ProductTemplatePage;

export const pageQuery = graphql`
  query ProductTemplatePageQuery($id: String!, $productCategoryTitles: [String!]!) {
    contentfulProduct(id: { eq: $id }) {
      metaTitle
      metaDescription
      id
      contentful_id
      skuNumber
      rto
      financingAvailable
      title
      senseiProductId
      imageSrc
      image {
        gatsbyImageData(quality: 50)
        fluid {
          srcWebp
        }
      }
      price
      width
      length
      height
      city
      state
      zipcode
      url
      buildingTags
      roofStyleType
      manufacturer
      gaugeTubing
      gaugePanels
      buildingCondition
      description {
        childMarkdownRemark {
          html
        }
      }
      specifications {
        childMarkdownRemark {
          html
        }
      }
      productCategories {
        title
      }
      buildingTags
      roofStyleType
      manufacturer
      gaugeTubing
      gaugePanels
      buildingDescription {
        internal {
          content
        }
      }
    }
    allContentfulProduct(
      filter: {
        id: {ne: $id}
        productCategories: {elemMatch: {title: {in: $productCategoryTitles}}}
      }
    ) {
      edges {
        node {
          id
          senseiProductId
          url
          rto
          financingAvailable
          skuNumber
          title
          image {
            gatsbyImageData(quality: 50, placeholder: BLURRED)
            fluid {
              srcWebp
            }
          }
          price
          width
          length
          height
          city
          state
          zipcode
          location {
            lat
            lon
          }
          buildingCondition
          description {
            childMarkdownRemark {
              html
            }
          }
          specifications {
            childMarkdownRemark {
              html
            }
          }
          productCategories {
            title
          }
          buildingTags
          roofStyleType
          manufacturer
          gaugeTubing
          gaugePanels
        }
      }
    }
  }
`;